import React, { useContext, useState, useEffect } from 'react';
import Layout from '../components/Layout';
import Steps from '../components/StepsReturning';
import Back from '../components/Back';
import { GlobalContext } from '../reducers/global';
import langs from '../translations/langs';
import Button from '../components/Button';

;

const ReturningUserSuccess = ({ setPage }) => {
    const {
        state: { options },
        dispatch,
    } = useContext(GlobalContext);

    const [unit] = useState('');

    // Data sets come from language files
    const { dataSets, defaultDataSet, returning } = langs[options.language];
    // if this isn't working something is wrong in the translate.json file/files
    const defaultFirstDataSet = dataSets.filter((val) => val.id === defaultDataSet)
    const defaultDataSetName = defaultFirstDataSet && defaultFirstDataSet[0].name;
    const [dataset] = useState(defaultDataSetName);

    useEffect(() => {
        dispatch({
            type: 'OPTIONS_UPDATE',
            dataSet: dataset,
        });
    }, [dataset, dispatch]);

    useEffect(() => {
        dispatch({
            type: 'OPTIONS_UPDATE',
            measurementSystem: unit,
        });
    }, [unit, dispatch]);

    const continueButton = () => {
        setPage('returnStep1');
    };

    return (
        <Layout>
            <Back
                onClick={() => {
                    setPage('step0');
                }}
            />
            <Steps current={1} />
            <div className="successTick" />
            <h3>{returning.successTitle}</h3>
            <p>{returning.successText}</p>
            
            <Button buttonStyle="primary" text={returning.successButton} onClick={continueButton} />
        </Layout>
    );
};

export default ReturningUserSuccess;
